export interface FormValues {
	name: String,
	symbol: String,
	tags: String[],
	platforms: String[]
	video: String
}

export const FORM_CONFIG = {
	FORM_PAGES_COUNT: 15,
	FIRST_FORM_PAGE: 1 ,
	DEFAULT_CARTRIDGE_NUMBER: 1,
	AVAILABLE_CARTRIDGES: [1, 2, 3],
	MAX_SYMBOL_LENGTH: 6,
	INITIAL_VALUES: {
		name: 'Game Name', // Name of the Game
		symbol: 'GME', // Token symbol ex. BTC
		totalSupply: 100000,
		transferFee: '20',
		gameUrl: 'https://pbs.twimg.com/profile_images/1453357868216954880/TKipFlwz_400x400.jpg',
		description: '',
		media: {
			cover: 'https://pbs.twimg.com/profile_images/1453357868216954880/TKipFlwz_400x400.jpg', //
			logoUrl: 'https://pbs.twimg.com/profile_images/1453357868216954880/TKipFlwz_400x400.jpg', ///
			
			banner: '', /// /
		},
		cartridge: 'gold',
		socials: {
			facebook: '',
			twitter: '',
			youtube: '',
			discord: '',
		},
		colors: {
			actionColor: '#FF3F3F',
			textColor: '#ffffff',
			backgroundColor: '#1a1a1a',
		},
		screenshots: [],
		genre: [],
		platforms: [],
		tags: [],
		video: '',
		marketplaceFee: '35',
		gamepaper: '',
		price: '10',
		cryptocurrency: '0x6388087689F441B63f7A80A6555c905B8Fd53f37',
		storeSupply: 10000,
		email: '',
		cartridgeAddress: '',
	} as FormValues,
};
